import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import {
  defaultMetaObj,
  initialUserPrimaryDashboardStateState,
} from "store/constants";
import { NotificationManager } from "react-notifications";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";

const { primaryDashboardEndPoint } = endPoints;

export const fetchUserPrimaryDashboardState = createAsyncThunk(
  "primaryDashboardState/fetchUserPrimaryDashboardState",
  async (
    { searchParamsObj = {} }: { searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: 1,
      endpoint: primaryDashboardEndPoint,
      searchParams: {
        ...searchParamsObj,
      },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserPrimaryDashboardState = createAsyncThunk(
  "primaryDashboardState/updateUserPrimaryDashboardState",
  async ({ updatedData, dashboardId }: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.update(
        primaryDashboardEndPoint,
        dashboardId,
        updatedData
      );
      if (response.status === 204) {
        // NotificationManager.success("updated Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const userPrimaryDashboardStateSlice = createSlice({
  name: "primaryDashboardState",
  initialState: initialUserPrimaryDashboardStateState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch user dashboard state
    builder
      .addCase(fetchUserPrimaryDashboardState.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchUserPrimaryDashboardState.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.userPrimaryDashboard = action.payload?.objects[0] as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchUserPrimaryDashboardState.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.meta = defaultMetaObj;
        }
      );

    //   update user dashboard state
    builder
      .addCase(updateUserPrimaryDashboardState.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        updateUserPrimaryDashboardState.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        updateUserPrimaryDashboardState.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const userPrimaryDashboardStateReducer =
  userPrimaryDashboardStateSlice.reducer;
